import React from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { TicketKey } from 'flow/types/EntityKeys';
import { ContactType } from 'flow/utils/extension-utils';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';
import { segmentTrack } from 'flow/actions/segment-actions';
import { selectVisitorContact } from 'flow/selectors/TicketsSelectors';
import { selectUserCountryCode } from 'flow/selectors/ExtensionSelectors';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import MenuItem from 'flow/components/ui-components/MenuItem';

type Props = {
    ticketKey: TicketKey;
};

const MenuItemContactAction = ({ ticketKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { openModal } = useModal();

    const visitorContact = useAppSelector((state) =>
        selectVisitorContact(state, ticketKey),
    );
    const ownCountryCode = useAppSelector(selectUserCountryCode);

    const onClickCreateGoToContact = (event?: React.MouseEvent) => {
        event?.stopPropagation();
        if (
            visitorContact?.get('key') ||
            visitorContact?.get('type') === ContactType.global.key
        ) {
            openModal('ticketContactModal', { ticketKey });
            dispatch(
                segmentTrack(TICKET_STRINGS.OPENED_CONTACT_MODAL, {
                    component: 'ticket context menu',
                }),
            );
        } else {
            openModal('createContact', {
                contact: visitorContact,
                countryCode: ownCountryCode,
            });
            dispatch(
                segmentTrack(TICKET_STRINGS.OPENED_CREATE_CONTACT_MODAL, {
                    component: 'ticket context menu',
                }),
            );
        }
    };

    return (
        <MenuItem onClick={onClickCreateGoToContact}>
            <span>
                {i18next.t(
                    geti18KeyCreateGoToContact(visitorContact?.get('type')),
                )}
            </span>
        </MenuItem>
    );
};

export default MenuItemContactAction;

const geti18KeyCreateGoToContact = (type?: string) => {
    switch (type) {
        case ContactType.bound.key:
        case ContactType.global.key:
        case ContactType.shared.key:
        case ContactType.personal.key:
            return 'Chat.Details.GoToContactCard';
        default:
            return 'Colleagues.Create.External.Title';
    }
};
